import { z } from 'zod'
import { ALLOWED_CTA_SCHEMES } from './format'

// Zod schema compartido entre crear y editar. La fecha acepta YYYY-MM-DD
// (formato nativo del input type="date").
export const noticiaFormSchema = z.object({
  titulo: z
    .string()
    .trim()
    .min(1, 'El título es obligatorio.')
    .max(120, 'Máximo 120 caracteres.'),
  descripcion: z
    .string()
    .trim()
    .min(1, 'La descripción es obligatoria.'),
  ctaTexto: z
    .string()
    .trim()
    .min(1, 'El texto del CTA es obligatorio.')
    .max(60, 'Máximo 60 caracteres.'),
  ctaUrl: z
    .string()
    .trim()
    .min(1, 'La URL del CTA es obligatoria.')
    .refine(
      (value) => ALLOWED_CTA_SCHEMES.some((scheme) => value.startsWith(scheme)),
      'Debe empezar con https://, wa.me/, tel: o mailto:.',
    ),
  fechaPublicacion: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Fecha inválida.'),
  featured: z.boolean(),
  estado: z.enum(['BORRADOR', 'PUBLICADA']),
})

export type NoticiaFormValues = z.infer<typeof noticiaFormSchema>
